import { RightDrawer } from '@/components/ui/right-drawer.js';
import { toRawAirId } from '@airreading/common';
import { ClassSessionsDrawerContent } from './content.js';

interface ClassSessionsDrawerProps {
  trigger: React.ReactNode;
  classId: string;
}

export function ClassSessionsDrawer({ trigger, classId }: ClassSessionsDrawerProps) {
  // Convert UUID to Air ID for display (API still uses UUIDs internally)
  // Show full Air ID in drawer title (not the stub)
  const airId = toRawAirId(classId);

  return (
    <RightDrawer
      trigger={trigger}
      title={
        <div>
          <div className="text-[30px] font-semibold mb-2">Class Sessions</div>
          <div className="text-sm text-gray-500">Sessions for Class ID: {airId}</div>
        </div>
      }
      shouldConfirmOnCloseModal={false}
      widthClass="w-[60%] min-w-[1000px] max-w-[90%] bg-[#F7F7F9]"
    >
      {() => {
        return (
          <div className="p-6 -m-6 h-[calc(100vh-120px)]">
            <div className="h-full">
              <ClassSessionsDrawerContent classId={classId} />
            </div>
          </div>
        );
      }}
    </RightDrawer>
  );
}
